import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormComponentProps } from '../../../global-forms/GlobalForms.types';
import { QueryFactory } from '@lmt/shared-types';
import styles from '@lmt/unicorn-shared/app/components/global-forms/Content.module.scss';
import { Button } from '../../../common/ui-kit/buttons/Button';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { isEmpty } from '../../../measurements/copy-datablock-field/common';
import localStyles from './MovePatientsForm.module.scss';

export type Props = FormComponentProps & {
  processId: string;
};
export const MovePatientsForm: React.FC<Props> = React.memo(
  function MovePatientsForm(props) {
    const { formType, formId, tryCompleteForm } = props;
    const i18next = useScopedTranslation('subtenants.list.move_patients_form');
    const moveResultQuery =
      QueryFactory.PatientQuery.useGetMovePatientsResultQuery(props.processId, {
        refetchInterval: 1000,
      });
    const isFinished = moveResultQuery.data?.isFinished;
    const errors = moveResultQuery.data?.errors;

    const onCopy = useCallback(async () => {
      if (!errors || !errors.length) {
        return;
      }
      await navigator.clipboard.writeText(errors.join('\n'));
    }, [errors]);

    useEffect(() => {
      props.setIsCloseButtonHidden(props.formId, !isFinished);
    }, [isFinished]);

    useEffect(() => {
      if (isFinished && isEmpty(errors)) {
        onClose().catch((e) => console.log(e));
      }
    }, [isFinished]);

    const onClose = useCallback(async () => {
      await tryCompleteForm(formType, formId, async () => {
        return true;
      });
    }, [formType, formId, tryCompleteForm]);

    const statusMessage = useMemo(() => {
      if (isEmpty(errors)) {
        return i18next.t('process_status');
      } else {
        return i18next.t('conflicts_status');
      }
    }, [isFinished, errors]);

    return (
      <div className={styles.autoSizedContainer}>
        <div className={styles.dataContainer}>
          <div className={localStyles.status}>{statusMessage}</div>
          {errors && errors.length > 0 && (
            <div className={localStyles.errorList}>
              {moveResultQuery.data?.errors?.map((error) => (
                <div className={localStyles.error}>{error}</div>
              ))}
            </div>
          )}
        </div>
        <div className={styles.submitContainer}>
          <Button
            className={styles.submit}
            disabled={!isFinished}
            title={i18next.t('copy_button')}
            onClick={onCopy}
          />
        </div>
      </div>
    );
  },
);
